
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '../../modules/material/material.module';
import { ShareDirectivesModule } from '../../../core/directives/directives.module';
import { SharePipesModule } from '../../../core/pipes/pipes.module';
import { TdValueComponent } from './td-value.component';

@NgModule({
  declarations: [
    TdValueComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ShareDirectivesModule,
    SharePipesModule,
  ],
  exports: [
    TdValueComponent
  ],

})
export class TdValueModule { }
